module.exports = __webpack_public_path__ + "static/cmac-logo-0f71f2aecf02c3fcf349bed046dca1bc.webp";